import { render, staticRenderFns } from "./insertSaleAddonCharacter.vue?vue&type=template&id=18d14f63&"
import script from "./insertSaleAddonCharacter.vue?vue&type=script&lang=js&"
export * from "./insertSaleAddonCharacter.vue?vue&type=script&lang=js&"
import style0 from "./insertSaleAddonCharacter.vue?vue&type=style&index=0&id=18d14f63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports